import { render, staticRenderFns } from "./NewTransfer.vue?vue&type=template&id=ebe24d48&"
import script from "./NewTransfer.vue?vue&type=script&lang=js&"
export * from "./NewTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports